import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { EmailVerify } from '@components/EmailVerify'
import useVerification from '@components/hooks/useVerification'
import TokenVerifyTest from '@components/TokenVerifyTest'

const VerifyRoute: React.FC = () => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const urlToken = searchParams.get('token')
  const urlEnv = searchParams.get('env')

  const [activeToken, setActiveToken] = useState<string | null>(urlToken)
  const [activeEnv, setActiveEnv] = useState<string | null>(urlEnv)

  const handleTestTokenSubmit = (token: string, env: string) => {
    setActiveToken(token)
    setActiveEnv(env)
  }

  const {
    isEmailVerified,
    isLoading,
    error,
    isTokenExpired,
    isTokenInvalid,
    isTooManyRequests,
  } = useVerification(activeToken, activeEnv)

  return (
    <>
      <TokenVerifyTest onTokenSubmit={handleTestTokenSubmit} />
      <EmailVerify
        isLoading={isLoading}
        isEmailVerified={isEmailVerified}
        error={error}
        isTokenExpired={isTokenExpired}
        isTokenInvalid={isTokenInvalid}
        isTooManyRequests={isTooManyRequests}
      />
    </>
  )
}

export default VerifyRoute
